if (!customElements.get('product-info-tabs')) {
  customElements.define('product-info-tabs', class ProductInfoTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.js-product-info-tabs__tab');
      this.panels = this.querySelectorAll('.js-product-info-tabs__panel');
      this.readMoreBtns = this.querySelectorAll('.js-product-info-tabs__read-more');
      
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabClick.bind(this, tab));
      });

      this.readMoreBtns.forEach((btn) => {
        btn.addEventListener('click', this.onReadMoreClick.bind(this, btn));
      });
    }

    onTabClick(clickedTab) {      
      const isActive = clickedTab.classList.contains('product-info-tabs__tab--active');
      const isMobile = window.innerWidth < 750;

      this.tabs.forEach((tab) => {
        tab.classList.remove('product-info-tabs__tab--active');
        tab.setAttribute('aria-selected', 'false');
      });

      this.panels.forEach((panel) => {
        panel.classList.remove('product-info-tabs__panel--active');
      });

      if (isActive && isMobile) {
        return; 
      }

      clickedTab.classList.add('product-info-tabs__tab--active');
      clickedTab.setAttribute('aria-selected', 'true');

      const panelId = clickedTab.getAttribute('aria-controls');
      const panel = this.querySelector(`#${panelId}`);
      if (panel) {
        panel.classList.add('product-info-tabs__panel--active');
      }
    }

    onReadMoreClick(btn) {
      const panel = btn.closest('.js-product-info-tabs__panel');
      const content = panel ? panel.querySelector('.js-product-info-tabs__content') : this.querySelector('.js-product-info-tabs__content');
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';

      if (!isExpanded) {
        if (content) content.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = btn.dataset.readLess || 'Leer menos';
      } else {
        if (content) content.classList.remove('is-expanded');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = btn.dataset.readMore || 'Seguir Leyendo';
      }
    }
  });
}
